import React from "react";
import { Link } from "react-router-dom";
import { Paw } from "../components/Doodles";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="terms-page">
      <p className="font-typewriter text-sm tracking-[0.3em] text-[#C84B31] mb-2">/ THE FINE PRINT</p>
      <h1 className="font-brush text-6xl sm:text-7xl leading-none">TERMS & DISCLAIMER</h1>
      <Paw className="w-10 opacity-30 mt-4" />

      <div className="paper-card !bg-[#FDFBF7] p-8 sm:p-10 mt-8 font-typewriter text-sm leading-relaxed space-y-6 text-[#111]">
        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">1 · WHAT THIS IS</h2>
          <p>
            Ask Kimberley provides general dog guidance, behavioural insight, training suggestions and personal opinion based on more than two decades of real-world experience across U.S. Air Force dog handling, rescue work, behaviour cases, and pet brand work. It is one experienced dog person sharing what she has learned.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">2 · WHAT THIS IS NOT</h2>
          <p>
            Ask Kimberley is <strong>not</strong> veterinary advice, medical diagnosis, treatment, or a substitute for professional veterinary care. Kimberley is not a licensed veterinarian, veterinary nurse, or animal behaviourist registered with any veterinary or psychological board.
          </p>
          <p className="mt-2">
            If your dog is unwell, injured, in distress, has been bitten, has bitten another animal or person, or is in any kind of emergency — <strong>contact a licensed veterinarian or emergency vet hospital immediately.</strong> Do not wait for a reply from Ask Kimberley.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">3 · NO GUARANTEES</h2>
          <p>
            Every dog is different. Advice is offered in good faith based on the information you provide, but no specific outcome, behavioural change, training result, or improvement is guaranteed. You are responsible for assessing whether any suggestion is appropriate for your dog, your household, and your circumstances.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">4 · NO LIABILITY</h2>
          <p>
            To the fullest extent permitted by law, Ask Kimberley, Kimberley personally, and any related entities are not liable for any loss, injury, harm, damage, cost, expense, or consequence — direct or indirect — arising from your reliance on or use of any guidance, recommendation, or opinion provided through this service. You use the service entirely at your own risk and discretion.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">5 · PAYMENT & REFUNDS</h2>
          <p>
            All payments are processed securely through Stripe. Quick Questions are charged at $29 NZD and Behaviour Reviews at $149 NZD. Refunds may be considered on a case-by-case basis where Kimberley is genuinely unable to provide a meaningful response — contact <a href="mailto:helloaskkimberley@gmail.com" className="underline">helloaskkimberley@gmail.com</a>.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">6 · YOUR INFORMATION</h2>
          <p>
            Your name, email, dog details, and any videos or photos you share via WhatsApp are used solely to answer your question. We do not sell or share your personal data. Unsubscribe from the weekly tip at any time at <Link to="/unsubscribe" className="underline">askkimberley.com/unsubscribe</Link>.
          </p>
        </section>

        <section>
          <h2 className="font-brush text-2xl tracking-widest mb-2">7 · ACCEPTANCE</h2>
          <p>
            By submitting a question or booking a behaviour review, you confirm that you have read, understood, and accepted these terms.
          </p>
        </section>

        <p className="font-cormorant italic text-sm mt-6 text-[#4A4A4A]">
          Last updated: February 2026 · For any questions about these terms, email{" "}
          <a href="mailto:helloaskkimberley@gmail.com" className="underline">helloaskkimberley@gmail.com</a>.
        </p>
      </div>

      <div className="mt-10 text-center">
        <Link to="/" data-testid="terms-home-btn" className="btn-brutal">BACK HOME</Link>
      </div>
    </div>
  );
}
